import { useOfferingType } from '@/hooks/useOfferingType';
import { ProductQuestionGenerator } from './QuestionGenerator.product';
import { ServiceQuestionGenerator } from './QuestionGenerator.service';

/**
 * Thin router that delegates to the correct question generator
 * based on the selected site's offering_type.
 *
 * - 'product' (default) -> ProductQuestionGenerator  (original component)
 * - 'service'           -> ServiceQuestionGenerator   (service characteristic questions)
 * - 'mixed'             -> Both stacked vertically
 */
export default function QuestionGenerator() {
  const offeringType = useOfferingType();

  switch (offeringType) {
    case 'service':
      return <ServiceQuestionGenerator />;
    case 'mixed':
      return (
        <div className="space-y-8">
          <div>
            <h2 className="text-lg font-semibold mb-4">Product Questions</h2>
            <ProductQuestionGenerator />
          </div>
          <div>
            <h2 className="text-lg font-semibold mb-4">Service Questions</h2>
            <ServiceQuestionGenerator />
          </div>
        </div>
      );
    case 'product':
    default:
      return <ProductQuestionGenerator />;
  }
}
